import { useEffect } from "react";

import type { SetStepNoOptions, SingleBuildingFormState } from "../model/types";

import { isFormFilled } from "../components/action/lib/createSubmitAction";

export const useEnforceAddressStep = ({
  formData,
  isPrefillingFormData,
  projectId,
  setStepNo,
  stepNo,
}: {
  formData: SingleBuildingFormState;
  isPrefillingFormData: boolean;
  projectId: string | undefined;
  setStepNo: (stepNo: number, options?: SetStepNoOptions) => void;
  stepNo: number;
}) => {
  useEffect(() => {
    if (projectId || isPrefillingFormData || stepNo <= 0) return;

    if (!isFormFilled(formData, projectId)) {
      setStepNo(0, { replace: true });
    }
  }, [formData, isPrefillingFormData, projectId, setStepNo, stepNo]);
};
